import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import { ParagraphElement } from '~/components/organism/PluginsEditor/types';
import serialize from './serialize';

export type Props = RenderElementProps & {
  element: ParagraphElement;
};

const Paragraph: React.FCC<Props> = ({
  dataTestId,
  attributes,
  element,
  children,
}) => (
  <Container data-testid={dataTestId} {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.p<{}>``;

export default {
  nodeName: 'P',
  renderComponent: props => <Paragraph {...props} />,
  deserialize: () => ({
    type: ELEMENTS.PARAGRAPH,
  }),
  serialize,
};
